import PropTypes from 'prop-types';

import { LoadingSpinner } from '../../loading-spinner';

import styles from './CurrentLocationButton.scss';

const style = {
  width: '16px',
  height: '16px',
};

export const CurrentLocationButton = ({ isLocationLoading, onClick }) => (
  <div className={styles.CurrentLocationContainer} data-testid="CurrentLocationButton">
    <button
      className={styles.useCurrentLocation}
      disabled={isLocationLoading}
      type="button"
      onClick={onClick}
    >
      <span>Use current location</span>
    </button>
    {isLocationLoading && (
      <LoadingSpinner spinnerStyle={style} extraClassName={styles.LoadingSpinner} />
    )}
  </div>
);

CurrentLocationButton.propTypes = {
  isLocationLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
